import * as moment from 'moment';

export class DateHelper {
  public static getPastDays(date: Date): number {
    return moment().diff(moment(date), 'days');
  }

  public static isToday(date: Date): boolean {
    return new Date().toDateString() === new Date(date).toDateString();
  }
}
